export default __webpack_public_path__ + "static/media/DtVhJx26TKEr37c9YHZ5k3wJxArepzhN.1c00810c.woff2";